module.exports = __webpack_public_path__ + "media/images/tiktok-a8d351ca29a8aefeabfe2b698fd2e3dd.png";